'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_GeneralPracticeUserReference$$anon$7(evaluator$6) {
  this.Lapp_api_GeneralPracticeUserReference$$anon$7__f_evaluator$2 = null;
  this.Lapp_api_GeneralPracticeUserReference$$anon$7__f_evaluator$2 = evaluator$6;
}
export { $c_Lapp_api_GeneralPracticeUserReference$$anon$7 as $c_Lapp_api_GeneralPracticeUserReference$$anon$7 };
$c_Lapp_api_GeneralPracticeUserReference$$anon$7.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_GeneralPracticeUserReference$$anon$7.prototype.constructor = $c_Lapp_api_GeneralPracticeUserReference$$anon$7;
/** @constructor */
function $h_Lapp_api_GeneralPracticeUserReference$$anon$7() {
}
export { $h_Lapp_api_GeneralPracticeUserReference$$anon$7 as $h_Lapp_api_GeneralPracticeUserReference$$anon$7 };
$h_Lapp_api_GeneralPracticeUserReference$$anon$7.prototype = $c_Lapp_api_GeneralPracticeUserReference$$anon$7.prototype;
$c_Lapp_api_GeneralPracticeUserReference$$anon$7.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lapp_api_GeneralPracticeUserReference$$anon$7.prototype.apply__s_Option = (function() {
  var v = this.Lapp_api_GeneralPracticeUserReference$$anon$7__f_evaluator$2.apply__O();
  return (((typeof v) === "string") ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(v) : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
});
$c_Lapp_api_GeneralPracticeUserReference$$anon$7.prototype.apply__O = (function() {
  return this.apply__s_Option();
});
var $d_Lapp_api_GeneralPracticeUserReference$$anon$7 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_GeneralPracticeUserReference$$anon$7, "app.api.GeneralPracticeUserReference$$anon$7", ({
  Lapp_api_GeneralPracticeUserReference$$anon$7: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lapp_api_GeneralPracticeUserReference$$anon$7 as $d_Lapp_api_GeneralPracticeUserReference$$anon$7 };
//# sourceMappingURL=app.api.-General-Practice-User-Reference$$anon$7.js.map
